export default __webpack_public_path__ + "static/media/smiths.d7229c82.jpg";